const styles = {
  wrapper: {
    padding: "4px 10px",
    fontSize: "12px",
    borderRadius: "4px",
    backgroundColor: "#af2a32",
    color: "white"
  }
};

export {
  styles
}
